import { Observable, ObservableInput } from "rxjs";
import { AjaxError, AjaxResponse } from "rxjs/ajax";
import { catchError } from "rxjs/operators";

export const retryAnyNonFatalAjax = () => retryNonFatalAjax((err, retry) => retry);

export const retryNonFatalAjax = <R>(
    selector: (err: any, caught: Observable<AjaxResponse>) => ObservableInput<R>
) => (source: Observable<AjaxResponse>) =>
    source.pipe(
        catchError((err, retry) => {
            if (isWrongToken(err)) {
                throw err;
            }
            console.warn("ajax failed", err);
            return selector(err, retry);
        })
    );

export const isWrongToken = (err: any) => {
    if (err instanceof AjaxError) {
        const { status } = err;
        if (status === 401 || status === 403) {
            return true;
        }
    }
    return false;
};
